module.exports = __webpack_public_path__ + "img/tallos-logo-name.e468d5c5.png";